import { Breakpoints } from '@nextgen-web-framework/all';
type Image = {
  url: string;
};

type Images = {
  alt_text: string;
  image: Image;
  viewport: string[];
};

type Asset = {
  images: Images[];
};

type categoryDataType = {
  category_id?: string;
  category_name?: string;
  background_color?: string;
  text_color?: string;
};

type termsAndConditionsType = {
  title?: string;
  description: string;
};

type cartCmsDataType = {
  list_no_products_found?: Asset;
  admin_no_rules_image?: Asset;
  admin_no_search_results?: Asset;
  list_category?: Array<categoryDataType>;
  kit_terms_and_conditions?: termsAndConditionsType;
};

export const myListCmsDataTransformer = (req: cartCmsDataType): Images => {
  const images = req.list_no_products_found?.images;
  const img = (images && Array.isArray(images) && images[0]) || {
    image: {
      url: '',
    },
    viewport: [Breakpoints.XS, Breakpoints.XL, Breakpoints.SM, Breakpoints.MD, Breakpoints.LG],
    alt_text: '',
  };
  return img;
};

export const listCategoryDataTransformer = (req: cartCmsDataType): Array<categoryDataType> => {
  const category = req.list_category || [];
  return category;
};

export const adminNoRulesImage = (req: cartCmsDataType): Images => {
  const images = req.admin_no_rules_image?.images;
  const img = (images && Array.isArray(images) && images[0]) || {
    image: {
      url: '',
    },
    viewport: [Breakpoints.XS, Breakpoints.XL, Breakpoints.SM, Breakpoints.MD, Breakpoints.LG],
    alt_text: '',
  };
  return img;
};

export const adminNoSearchRulesImage = (req: cartCmsDataType): Images => {
  const images = req.admin_no_search_results?.images;
  const img = (images && Array.isArray(images) && images[0]) || {
    image: {
      url: '',
    },
    viewport: [Breakpoints.XS, Breakpoints.XL, Breakpoints.SM, Breakpoints.MD, Breakpoints.LG],
    alt_text: '',
  };
  return img;
};
export { cartCmsDataType, Images, categoryDataType };
